import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { NavLink } from 'react-static'

import logo from './afrodesiamedia.svg'

class Nav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false
    }
  }
  handleToggle(e) {
    e.preventDefault()
    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }
  render() {
    const { isExpanded } = this.state

    const closeMenu = () =>
      this.setState({
        isExpanded: false
     })

    return (
      <header>
        <div className="logo">
          <a href="/">
            <img src={logo} alt="afrodesiamedia.com" title="afrodesiamedia.com" />
            <span className="name">afrodesia</span>
            <span className="gray">media</span>
          </a>
        </div>
        <nav className="nav">
          <i
            className="fas fa-bars"
            aria-hidden="true"
            onClick={e => this.handleToggle(e)}
          />
          <ul className={`collapsed ${isExpanded ? "is-expanded" : ""}`}>
            <li>
              <NavLink 
                activeClassName="active"
                onClick={closeMenu} 
                to="/about">
                <span>about</span>
              </NavLink>
            </li>
            <li>
              <NavLink 
                activeClassName="active" 
                onClick={closeMenu} 
                to="/news">
                <span>news</span>
              </NavLink>
            </li>
            <li>
              <NavLink 
                activeClassName="active" 
                onClick={closeMenu} 
                to="/process">
                <span>process</span>
              </NavLink>
            </li>

            <li>
              <NavLink 
                activeClassName="active"
                onClick={closeMenu}  
                to="/contact">
                <span>contact</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
    )
  }
}

export default withRouter(Nav)



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/includes/NavBar/Nav.js